import { KeysTabsAnalysis } from "@app/types/samples.types";
import { useFormContext } from "react-hook-form";
import IGForm from "./gammaSubForm/isotopico";
import GammaTotalForm from "./gammaSubForm/gammaTotal";

interface GammaFormProps {
  mode: string;
}

const GammaForm = ({ mode }: GammaFormProps) => {
  const { getValues } = useFormContext();
  const analysisValue = getValues("analysis");
  
  // Manejar tanto array como objeto único
  const codeAnalysis = Array.isArray(analysisValue) 
    ? analysisValue[0]?.codigo 
    : analysisValue?.codigo;

  if (!codeAnalysis) return null;

  if (codeAnalysis === KeysTabsAnalysis.IG) {
    return <IGForm mode={mode} />;
  }

  return <GammaTotalForm mode={mode} />;
};

export default GammaForm;
